var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#36424A",
    strokeWidth: 1.3,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.9 8 1.6a1.5 1.5 0 0 1 2.6 1.5L9.4 6.2h3.4a1.5 1.5 0 0 1 1.45 1.9l-1.35 4.8a1.5 1.5 0 0 1-1.45 1.1H4.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.9H2.2a.6.6 0 0 0-.6.6v5.9a.6.6 0 0 0 .6.6h2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/ThumbUp.0b3910ca8da39e92859858f17aaf4f18.svg";
export { ForwardRef as ReactComponent };